import http from "../../utils/httpClient";

class reportService {
  // Order Report Service Start
  getExcelOrder = async (
    startDate,
    endDate,
    sku,
    paymentMethod,
    paymentStatus,
    orderSource,
    orderStatus,
    shopId,
    categoryId
  ) => {
    return await http.get(
      `/api/Order/GenerateExcelOrderV2?getAll=Y&startDate=${startDate}&endDate=${endDate}&sku=${sku}&paymentStatus=${paymentStatus}&paymentMethod=${paymentMethod}&orderSource=${orderSource}&statusName=${orderStatus}&shopId=${shopId}&categoryId=${categoryId}`
    );
  };
  // Order Report Service End

  // Order Invoice List Report Start
  getOrderInvoiceList = async (query) => {
    return await http.get(`/api/Order/GetShopwiseOrderByStatusWise`, {
      params: query,
    });
  };
  // Order Invoice List Report End

  // Order Invoice List Report Start
  getPOReport = async (query) => {
    return await http.get(`/api/Order/GetOrderReport`, { params: query });
  };
  // Order Invoice List Report End

  // Vendor-Wise Order Summary Report Start
  getOrderSummaryReport = async (query) => {
    return await http.get(`/api/Order/GetSalesReportSummaryShopwiseNbrV1`, {
      params: query,
    });
  };
  // Vendor-Wise Order Summary Report End

  // Style-Wise Order Summary Report Start
  getStyleWiseOrderSummaryReport = async (query) => {
    return await http.get(`/api/Order/GetStyleWiseOrderSummaryReport`, {
      params: query,
    });
  };
  // Style-Wise Order Summary Report End

  // Vendor Cash Distribution Report Start
  getCashDistributionReport = async (query) => {
    return await http.get(`/api/Order/GetCashDistribution`, { params: query });
  };
  // Vendor Cash Distribution Report End
}

export default new reportService();
